import React, { useEffect, useState } from "react";
import { getFilteredPosts } from "../services/posts.services";
import BlogStyle1 from "./BlogStyle1";
import BlogStyle2 from "./BlogStyle2";

const HomeWorldBusinessNews = () => {
    const [worldPosts, setWorldPosts] = useState(null);
    const [businessPosts, setBusinessPosts] = useState(null);

    const fetchWorldPosts = async () => {
        const response = await getFilteredPosts({ categories: ["World"] });
        console.log("WORLD POSTS ----> ", response);
        if (response.length > 0) {
            console.log(response.slice(0, 5));
            setWorldPosts(response.slice(0, 5));
        } else {
            setWorldPosts([]);
        }
    };

    const fetchBusinessNews = async () => {
        const response = await getFilteredPosts({ categories: ["Business"] });
        console.log("BUSINESS POSTS ----> ", response);
        if (response.length > 0) {
            console.log(response.slice(0, 5));
            setBusinessPosts(response.slice(0, 5));
        } else {
            setBusinessPosts([]);
        }
    };

    useEffect(() => {
        fetchWorldPosts();
        fetchBusinessNews();
    }, []);

    return (
        <section className="space">
            <div className="container">
                <div className="row">
                    <div className="col-xl-8">
                        <h2 className="sec-title has-line">Wolrd News</h2>
                    </div>
                    <div className="col-xl-4">
                        <div className="d-none d-xl-block">
                            <h2 className="sec-title has-line">
                                Business News
                            </h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {!worldPosts ? (
                        <p>Loading...</p>
                    ) : worldPosts.length === 0 ? (
                        <div className="col-xl-8">
                            <p>No World News</p>
                        </div>
                    ) : (
                        <>
                            <div className="col-xl-3">
                                <div className="row gy-4">
                                    <div className="col-xl-12 col-sm-6 border-blog">
                                        <BlogStyle1 post={worldPosts[0]} />
                                    </div>
                                    <div className="col-xl-12 col-sm-6 border-blog">
                                        <BlogStyle1 post={worldPosts[1]} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-5 mt-4 mt-xl-0">
                                <div className="">
                                    <BlogStyle1
                                        post={worldPosts[2]}
                                        hasStyleBig={true}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    <div className="col-xl-4 mt-35 mt-xl-0">
                        <div className="d-block d-xl-none">
                            <h2 className="sec-title has-line">
                                Business News
                            </h2>
                        </div>
                        <div className="row gy-4">
                            {!businessPosts ? (
                                <p>Loading...</p>
                            ) : businessPosts.length === 0 ? (
                                <div className="col-xl-4">
                                    <p>No Business News</p>
                                </div>
                            ) : (
                                <>
                                    <div className="col-xl-12 col-md-6 border-blog">
                                        <BlogStyle2 post={businessPosts[0]}/> 
                                    </div>
                                    <div className="col-xl-12 col-md-6 border-blog">
                                        <BlogStyle2 post={businessPosts[1]}/>
                                    </div>
                                    <div className="col-xl-12 col-md-6 border-blog">
                                        <BlogStyle2 post={businessPosts[2]}/>
                                    </div>
                                    <div className="col-xl-12 col-md-6 border-blog">
                                        <BlogStyle2 post={businessPosts[3]} />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeWorldBusinessNews;
